import React, { useState, useEffect } from "react";
import {
  Navbar,
  Container,
  Offcanvas,
  Nav,
} from "react-bootstrap";

export default function NavSide() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const sideBarStyle = {
    position: 'sticky',
    top: '0',
    zIndex: 1000,
    backgroundColor: scrolled ? 'black' : 'transparent',
    transition: 'background-color 0.3s ease',
    boxShadow: scrolled ? '0 2px 5px rgba(0,0,0,0)' : 'none'
  }

  return (
    <div style={sideBarStyle}>
<Navbar className={`resp-nav1 ${scrolled ? 'scrolled' : ''}`}  expand={false}>

<Container fluid>
          <Navbar.Brand href="/">
            <picture>
              <source srcSet="/img/logo23.webp" type="image/webp" />
              <img src="/img/logo23.png" width="50" alt="logo" />
            </picture>
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="offcanvasNavbar" />
          <Navbar.Offcanvas
            id="offcanvasNavbar"
            aria-labelledby="offcanvasNavbarLabel"
            placement="end"
          >
            <Offcanvas.Header closeButton></Offcanvas.Header>
            <Offcanvas.Body>
              <div className="sideBar">
                <Navbar.Brand href="/">
                  <picture>
                    <source srcSet="/img/logo23.webp" type="image/webp" />
                    <img className="logo-side-marg" src="/img/logo23.png" width="70" alt="logo" />
                  </picture>
                </Navbar.Brand>
                <Nav.Link href="/garaje"className='letrasNav'>
                Vehículos de ocasión
                </Nav.Link>
                <Nav.Link href="/tasación"className='letrasNav'>Tasación</Nav.Link>
                <Nav.Link href="/financiación"className='letrasNav'>Financiación</Nav.Link>
                <Nav.Link href="/servicios"className='letrasNav'>Servicios</Nav.Link>
                <Nav.Link href="/contacto"className='letrasNav'>Contacto</Nav.Link>
                <Nav.Link href="/faq"className='letrasNav'>FAQ</Nav.Link>
                <a href="tel:34664067584" className="nav__link active-link logoNavNone"> <img className='tlfn' src="/img/iconPhone.png" width='40' alt ='tlfn'/></a> 
              </div>
            </Offcanvas.Body>
          </Navbar.Offcanvas>
        </Container>
      </Navbar>
    </div>
  );
}
